import { render, staticRenderFns } from "./RegistrationGuests.vue?vue&type=template&id=f7a0c1a0&"
import script from "./RegistrationGuests.vue?vue&type=script&lang=js&"
export * from "./RegistrationGuests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports